import _ from 'lodash'
import store from '@/store'
import router from '@/router'
import $glDom from '@/services/$glDom'
import $glAuth from '@/services/$glAuth'

// beforeEach route transition
router.beforeResolve((to, from, next) => {
  // if: not logged in AND route requires authentication -> send to login
  // else if: logged in AND route requires unauthentication -> send to dashboard
  // else if: below admin AND route requires admin role -> send to dashboard
  // else: -> continue to next route
  if (!$glAuth.isLoggedIn() && _.includes(to.meta.requires, 'auth')) next({ name: 'login' })
  else if ($glAuth.isLoggedIn() && _.includes(to.meta.requires, 'unauth')) next({ name: 'dashboard' })
  else if ($glAuth.belowAdmin() && _.includes(to.meta.requires, 'admin')) next({ name: 'dashboard' })
  else next()
})

// afterEach route transition
router.afterEach((hook) => {
  // set document title
  document.title = hook.meta.title

  // if on login AND login config is found -> set title to config login title
  if (hook.name === 'login' && store.getters.config && store.getters.config.agency && store.getters.config.agency.ptLogin) {
    document.title = store.getters.config.agency.ptLogin
  }

  // if on dashboard AND dashboard config is found -> set title to config dashboard title
  if (hook.name === 'dashboard' && store.getters.config && store.getters.config.agency && store.getters.config.agency.ptDashboard) {
    document.title = store.getters.config.agency.ptDashboard
  }

  // scroll to the top of the page
  $glDom.scrollTop()

  // get fresh config
  $glAuth.getConfig()
})



// WEBPACK FOOTER //
// ./src/router/hooks.js